module.exports = __webpack_public_path__ + "static/img/pt2_en.b283ef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdwan/pt2_en.png
// module id = A0Yn
// module chunks = 0